import React, { FunctionComponent } from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import FacebookIcon from '@uniiverse/library/assets/icons/facebook.svg'
import TwitterIcon from '@uniiverse/library/assets/icons/twitter.svg'
import { shareToTwitter as shareTwitter, shareToFacebook as shareFacebook } from 'src/lib/navigate-to'
import { LoadingPlaceholder } from 'src/components/loading-content/LoadingPlaceholder'

const style = require('./Social.css')
import locale from './locale'

interface Props {
  eventData: any,
  hasBorder: Boolean,
  loading: Boolean,
  isEventSet?: Boolean,
  showSocial: Boolean,
}

const Placeholder = () => (
  <LoadingPlaceholder modifierClass={style.placeholder} />
)

const SocialComponent: FunctionComponent<Props & InjectedIntlProps> = ({
  eventData,
  hasBorder,
  loading,
  isEventSet = false,
  showSocial,
  intl: { formatMessage }
}) => {
  if (loading) return <Placeholder />

  const twitterText = formatMessage(locale.shareToTwitter, { listingTitle: eventData.title })
  const shareToTwitter = () => shareTwitter(eventData.slug, twitterText, isEventSet)
  const shareToFacebook = () => shareFacebook(eventData.slug, isEventSet)

  return (
    showSocial ?
      <div className={`${style.social} ${hasBorder ? style.socialWithBorder : ''}`}>
        <div className={style.socialIcons}>
          <span className={style.shareText}>{formatMessage(locale.socialShare)}</span>
          <button className={style.socialIconButton} onClick={shareToFacebook}>
            <FacebookIcon className={style.socialIcon} />
          </button>
          <button className={style.socialIconButton} onClick={shareToTwitter}>
            <TwitterIcon className={style.socialIcon} />
          </button>
        </div>
      </div>
      : null
  )
}

export const Social = injectIntl(SocialComponent)
